import { Alert, borderRadius, breakpoints } from '@toggle/design-system';
import styled from 'styled-components';

import { Description } from '~/components/chat-landing/ChatLanding.styles';

import { DRAWER_WIDTH } from './shared/ResearchSidebar.styles';

export const ForbiddenStyledAlert = styled(Alert)`
  margin-top: 10px;
  width: 100%;
  border-top-right-radius: ${borderRadius.r2};
  border-bottom-right-radius: ${borderRadius.r2};
`;

const THINKING_WIDTH = '600px';

export const MainContent = styled.main<{
  $isThinkingSidebarOpen: boolean;
  $rightDrawerOpen?: boolean;
}>`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  width: ${({ $rightDrawerOpen }) =>
    $rightDrawerOpen ? `calc(100% - ${DRAWER_WIDTH})` : '100%'};
  margin-right: ${({ $isThinkingSidebarOpen, $rightDrawerOpen }) => {
    if ($isThinkingSidebarOpen && $rightDrawerOpen) {
      return `calc(${DRAWER_WIDTH} + ${THINKING_WIDTH})`;
    }

    if ($isThinkingSidebarOpen) {
      return THINKING_WIDTH;
    }

    if ($rightDrawerOpen) {
      return DRAWER_WIDTH;
    }

    return '0';
  }};
  --inventory-right-offset: ${({ $rightDrawerOpen }) =>
    $rightDrawerOpen ? DRAWER_WIDTH : '0'};
  --chat-message-width: ${({ $isThinkingSidebarOpen, $rightDrawerOpen }) =>
    $isThinkingSidebarOpen && $rightDrawerOpen ? '640px' : '740px'};
  max-width: 100%;
  overflow-x: hidden;

  @media ${breakpoints.lsegMobile}, ${breakpoints.lsegTablet} {
    width: 100%;
    margin-right: 0;
    --chat-message-width: calc(100% - 16px);
  }
`;

export const ChatWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  transition: bottom 0.3s ease-in-out;
  width: 100%;

  ${Description} {
    text-align: center;
  }
`;

export const ChatInputComposerWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media ${breakpoints.lsegMobile} {
    gap: 12px;
  }
`;

export const StyledAlert = styled(Alert)`
  ${borderRadius.r2};
`;

export const Content = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const BannerContainer = styled.div`
  margin-bottom: 40px;
`;
